import axios from "axios";
import { logout } from "../lib/auth";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 商材一覧
export async function getTossUpFormOptionSelects(id: string) {
  try {
    const path = "tossUpFormOptionSelects";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
